module.exports = __webpack_public_path__ + "static/img/13.9d08396.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/11/zh/13.png
// module id = 0Vnr
// module chunks = 0